import { styled } from 'styled-components';

import { Button } from '#/components/Button/Button';
import { colors, cssBreakpoints } from '#/theme/theme';

export const AddTitlesIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const Container = styled.div`
  position: relative;
`;

export const StyledPrimaryButton = styled(Button)<{
  $initialized: boolean;
  $transitioned: boolean;
}>`
  transition: all 1s ease;
  height: 38px;
  opacity: 1;
  position: absolute;
  top: 0;
  width: 127px;

  ${(props) =>
    props.$initialized
      ? `
    background: ${colors.softBlue} !important;
    height: 100%;
    opacity: 0;
    width: 100%;
    pointer-events: none;`
      : undefined}

  ${(props) =>
    props.$transitioned
      ? `
    height: 38px;
    width: auto;`
      : undefined}
`;

export const CareerPathFormContainer = styled.div<{
  $hasError: boolean;
  $initialized: boolean;
  $transitioned: boolean;
}>`
  align-items: baseline;
  transition: clip-path 1s ease;
  clip-path: inset(0 100% 100% 0);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    align-items: center;
    background: ${(props) => {
      if (props.$hasError) {
        return colors.lightRed;
      }

      if (props.$initialized) {
        return colors.softBlue;
      }

      return colors.brandBlue;
    }};
    border-radius: 8px;
    height: 0;
    margin-bottom: 38px;
    flex-direction: row;
    gap: 0;
    padding: 0;

    ${(props) =>
      props.$initialized
        ? `
          clip-path: inset(0 0 0 0);
          height: auto;
          margin-bottom: 0;
          padding: 20px 40px;
        `
        : undefined}

    ${(props) =>
      props.$transitioned
        ? `
              clip-path: none;
              transition: none;
            `
        : undefined}
  }

  ${(props) =>
    props.$initialized
      ? `
        clip-path: inset(0 0 0 0);
        height: auto;
      `
      : undefined}

  ${(props) =>
    props.$transitioned
      ? `
        clip-path: none;
        transition: none;
      `
      : undefined}
`;

export const JobTitleFieldContainer = styled.div`
  flex: 1;
  position: relative;
  width: 100%;
`;

export const IconContainer = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  pointer-events: none;
  transform: translateY(-50%);
  z-index: 103;
`;

export const ButtonContainer = styled.div`
  color: ${colors.brandBlue};
  min-width: 35px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 103;
`;

export const CareerPathFormText = styled.div`
  flex: 1;
`;
